module.exports = __webpack_public_path__ + "img/icon-edit.cda77bfa.svg";